import { Component, OnInit } from '@angular/core';
import { OrderMenu } from '../../_models/orderMenu';
import { NgModule } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Globals } from '../../_models/globals';
import { User } from '../../_models/user';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { AlertService } from '../../_services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiIntegration } from '../../_services/api.integration';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-admin-shipment-list',
  templateUrl: './admin-shipment-list.component.html',
  styleUrls: ['./admin-shipment-list.component.css']
})
export class AdminShipmentListComponent implements OnInit {
  ordersMainMenu: OrderMenu[] = [
    { displayName: "Delivered", tabClicked: "delivered", orderStatus: "DELIVERED", additional: "N" },
    { displayName: "RTO (Return to Origin)", tabClicked: "rto", orderStatus: "RTO", additional: "N" }
  ];
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();

  tabClicked: string;
  orderStatus: any = 'DELIVERED';
  masterSelected: boolean = false;
  previousStatus = '';
  totalRecords: number;
  orders: any;
  checkedList: any;
  errorMessage: string;
  ohid: any;
  userDrop2: any = 'READY_TO_SHIP';
  pdfGenerate: string = 'N';
  awb: any = {
    tracking_data: "",
    track_status: "",
    shipment_status: "",
    shipment_track: [],
    shipment_track_activities: []
  };
  sizeError: string;
  size: string;

  constructor(private g: Globals, public user: User, private router: Router, private api: ApiIntegration, private alertService: AlertService, private http: HttpClient) {
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      for (let ol of this.ordersMainMenu) {
        if (ol.tabClicked === this.g.pageTab) {
          this.populateTabData(this.g.pageTab, ol.orderStatus);
        }
      }
    } else {
      this.tabClicked = "delivered";
      this.populateTabData('delivered', "DELIVERED");
    }
  }

  getOrdersByStatus(status) {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.dtOptions = {
      "ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: 'Search by Shipment #'
      },
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.orderStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.orderStatus;
        }
        let query: any = {
          status: this.orderStatus,
          organizationId: 1
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        if (this.user.role == 'ACCOUNT_OWNER' || this.user.role === "ROLE_USER" || this.user.role == 'DEMO_ACCOUNT') {
          query.accountOwnerId = this.user.accountOwnerId;
        }
        this.g.loaderDisplay = "display";

        this.http.get(environment.apiUrl + "api/getAllShipmentData", { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.orders = resp.shipmentData;
            this.g.loaderDisplay = "";
            this.totalRecords = resp.noOfOrders;
            this.orders.forEach((s) => {
              s['isSelected'] = false;
            });
            callback({
              recordsTotal: resp.noOfOrders,
              recordsFiltered: resp.noOfOrders
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    };
  }

  tabChange() {
    this.checkedList = [];
    this.errorMessage = "";
    this.g.loaderDisplay = "display";
  }

  populate(orderChange) {
    this.g.loaderDisplay = "display";
    this.api.getStockTransferList(orderChange, "ORDER", "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.orders = data.ordersData;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  close() {
    this.pdfGenerate = 'N';
    this.populateTabData('readyToShip', "READY_TO_SHIP");
  }

  validToDisplay(status) {
    let disable = true;
    let checkedList = [];
    if (this.orders && this.orders.length) {
      for (var i = 0; i < this.orders.length; i++) {
        if (this.orders[i].isSelected) {
          checkedList.push(this.orders[i]);
        }
      }
    }
    if (checkedList.length == 1) {
      if (this.tabClicked === 'readyToShip') {
        if (status === 'Carrier to be assigned' && checkedList[0].orderStatus === 'READY_TO_SHIP') {
          disable = false;
        }
        if (status === 'Generate Label' && checkedList[0].orderStatus === 'GENERATE_LABEL') {
          disable = false;
        }
        if (status === 'Label Generated' && checkedList[0].orderStatus === 'LABEL_GENERATED') {
          disable = false;
        }
      }
      if (this.tabClicked === 'awaitingCarrier') {
        if (status === 'Awaiting Carrier' && checkedList[0].orderStatus === 'AWAITING_CARRIER') {
          disable = false;
        }
        if (status === 'shipped' && checkedList[0].orderStatus === 'SHIPPED') {
          disable = false;
        }
      }
    } else {
      disable = true;
    }
    return disable;
  }

  printShipment() {
    this.sizeError = "";
    if (!this.size) {
      this.sizeError = 'Please select size';
    }
    if (this.sizeError != "") {
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/pdf');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.g.loaderDisplay = "display";
    this.http.post(environment.apiUrl + 'api/generateShippingLabelPDF', {
      "headerId": this.ohid.orderHeaderId,
      "organizationId": this.user.organizationId,
      "accountOwnerId": this.ohid.accountOwnerId,
      "size": this.size
    },
      { responseType: 'blob', headers: header1 }).subscribe((resp: any) => {
        console.log(resp);
        var mediaType = 'application/pdf';
        var blob = new Blob([resp], { type: mediaType });
        var filename = 'ShippingLabel.pdf';
        saveAs(blob, filename);
        this.g.loaderDisplay = "";
        this.pdfGenerate = 'N';
        this.populateTabData('readyToShip', "READY_TO_SHIP");
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }

  generateShippingLabel(orders) {
    let i = 0;

    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        this.ohid = order;
      }
    }
    ;
    if (i === 1) {
      this.pdfGenerate = 'Y';
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }

  selectAwaitingCarrier(orders) {
    let i = 0;
    let ohid;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    }
    ;
    if (i === 1) {
      this.awaitingCarrierFunction(ohid);
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }

  moveToInTransit(orders) {
    let i = 0;
    let ohid = {};
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    }
    ;
    if (i === 1) {
      this.inTransit(ohid);
    } else {
      this.errorMessage = "Can not Edit multiple Shipments at once. Please select one at a time";
    }
  }

  moveToShipped(orders) {
    let i = 0;
    let ohid = {};
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order;
      }
    }
    ;
    if (i === 1) {
      this.shipping(ohid);
    } else {
      this.errorMessage = "Can not Edit multiple Shipments at once. Please select one at a time";
    }
  }

  returnOrders(orders) {
    this.router.navigate(['/admin/returnOrder/' + this.checkedList[0]]);
  }

  selectShip(sl) {
    if (!sl.isSelected) {
      this.masterSelected = false
    }
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList = [];
    for (var i = 0; i < this.orders.length; i++) {
      if (this.orders[i].isSelected) {
        this.checkedList.push(this.orders[i]['orderHeaderId']);
      }
    }
  }

  trackByAWB(number) {
    this.api.trackShipmentByAWB(number).subscribe((data: any) => {
      this.awb = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }


  shipMultipleOrders(orders) {
    let i = 0;
    let ohid;
    for (let order of orders) {
      if (order.isSelected) {
        i = i + 1;
        ohid = order.orderHeaderId;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/ProcessingOrder/' + ohid]);
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }


  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(true);
    });
  }

  populateTabData(triggered, orderStatus) {
    this.tabClicked = triggered;
    this.orderStatus = orderStatus;
    if (!this.previousStatus) {
      this.getOrdersByStatus(orderStatus);
    } else {
      this.rerender();
    }
  }
  awaitingCarrierFunction(ord) {

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    if (ord.shippingOption !== "THIRD_PARTY") {
      this.g.loaderDisplay = "display";

      this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
        "orderHeaderId": ord.orderHeaderId,//this.route.snapshot.params['id'],
        "orderStatus": "AWAITING_CARRIER",
        "organizationId": 1
      },
        { headers: header1 }).subscribe(data => {
          this.checkedList = [];
          this.g.loaderDisplay = "";
          if (data['code'] == 200) {
            this.alertService.success('Order', 'Awaiting Carrier Successfully');

            let index = this.orders.indexOf(ord);
            this.orders.splice(index, 1);
            this.rerender();
          } else {
            this.alertService.error('Error', data['message']);
          }
        },
          (err: HttpErrorResponse) => {
            this.g.loaderDisplay = "";
          });
    } else {
      this.http.post(environment.apiUrl + 'api/pickUpRequestForShip?orderHeaderId=' + ord.orderHeaderId, {}, {
        headers: header1
      }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['pickup_status']) {
          this.alertService.success('PickUp Scheduled On :', data['response'].pickup_scheduled_date);
          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });

    }
  }

  inTransit(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,
      "orderStatus": "SHIPPED",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'In shipped Successfully');
          this.populateTabData('awaitingCarrier', "AWAITING_CARRIER");
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  shipping(ord) {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateOrderH&L', {
      "orderHeaderId": ord.orderHeaderId,
      "orderStatus": "DELIVERED",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Order', 'Delivered Successfully');

          let index = this.orders.indexOf(ord);
          this.orders.splice(index, 1);
          this.rerender();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


}
